var _module = require('../components/module.js');

_module.filter('absoluteUrl', function () {
    return function (input) {
        var lowercase_input = String(input).toLowerCase();

        if(!(lowercase_input.substr(0, 7) === 'http://' || lowercase_input.substr(0, 8) === 'https://')) {
            input = 'http://' + input;
        }

        return input;
    };
});
